<template>
    <div>
        <div class="container whiteBack">
            <div class="secureDni">
                <p class="boldTitle18">Para visualizar y firmar la solicitud introduce tu NIF</p>
                <div class="">
                    <div class="dniZone">
                        <div ref="nifLabel" v-if="nifLabel" class="infoDniBox">
                            <span class="infoDni">Introduce tu DNI/NIE</span>
                        </div>
                        <input type="nif" class="inputDni" maxlength="9" id="dni" ref="inputNif" placeholder="Introduce tu DNI/NIE">
                        <div>
                            <p id="red_dni" v-if="errorLetter">{{this.errorMessage}}</p>
                        </div>
                    </div>
                    <div class="checkbox checkOrange">
                        <input type="checkbox" @click="toogleCheck" id="acepto" value="1">
                        <label for="acepto" class="padLeft20">
                            Acepto que inicio un proceso de firma digital.
                        </label>
                        <p class="padLeft20"> Para más detalle<span class="linkCondition" @click="openPopUp" > pincha aquí</span></p>
                    </div>
                </div>
            </div>
            <!--botones-->
            <div class="buttonsLogin">
                <div class="buttonNextSecure">
                    <button class="botonGris btn-block" id="buttonNext" ref="btnNext" @click="login">Siguiente</button>
                </div>
            </div>
        </div>
        <!-- condiciones -->
        <div  class="popUpHidden boxPopConditions  centerCancelDiv" ref="popUpCondition" id="popUpConditions">
            <div class="divImgClose">
                <img src="../../assets/images/KO.png" @click="openPopUp" alt="close">
            </div>
            <div class="conditionText">
                <p class="pAlter">Las partes intervinientes en el proceso de firma del contrato son la parte emisora, que remite la propuesta contractual, y la parte receptora, a la que se dirige la misma, y las mismas aceptan perfeccionar el contrato de forma exclusivamente electrónica empleando el procedimiento establecido al efecto por DIGITEL ON TRUSTED SERVICES, S.L.U, con CIF B-47447560 (en adelante, “DIGITEL TS”), cuya intervención tiene como única finalidad que ésta genere y, en su caso, custodie la prueba electrónica que acredite la existencia y contenido del contrato, incluyendo, en su caso, las condiciones generales y/o particulares que se perfeccionen.</p>
                <p class="pAlter">A tales efectos, se remitirá a la parte receptora a su dirección de correo electrónico o al número de teléfono proporcionado, según su disponibilidad, un enlace único que permitirá la descarga de un ejemplar de las Condiciones Particulares y, en su caso, Generales del contrato y demás documentación asociada al mismo. Al mismo tiempo, se remitirá un SMS a su número de teléfono móvil con un código de operación. El acceso por la parte receptora a la referida documentación contractual se realizará de la siguiente forma:</p>
                <p class="pAlter">La parte receptora accederá al enlace único que se le ha remitido por correo electrónico o SMS (<a ref="link" :href=linkTo target="_blank">{{linkTo}}</a> ). Al acceder a éste, la parte receptora procederá a introducir el número de su DNI para el efectivo acceso a las Condiciones Particulares y Generales del contrato y demás documentación asociada al mismo. Una vez recogidas éstas, el Cliente/s podrá, tras su lectura, llevar a cabo a la aceptación de las mismas. Para ello, la parte receptora podrá subir una imagen tanto del anverso como del reverso de su documento de identidad (opcional) y procederá a teclear en la página web el código de operación recibido por SMS, generando de esta forma una prueba electrónica de su aceptación a las Condiciones Particulares y Generales y cualquiera otra documentación asociada al contrato.</p>
                <p class="pAlter">Conforme a lo establecido en el artículo 1255 del Código Civil, todas las partes firmantes intervinientes pactan la plena validez del procedimiento anteriormente descrito para la formalización contractual. Asimismo, DIGITEL TS se compromete, como Prestador de Servicios de Confianza, a actuar con absoluta neutralidad y confidencialidad, produciendo las pruebas electrónicas de la remisión y entrega de los documentos, a la garantía de su fecha y hora, mediante la generación de sellos de tiempo electrónico cualificados y, en su caso, custodiando de forma segura todos los documentos, datos y transacciones electrónicas generadas durante el periodo establecido por la parte emisora.</p>
                <p class="pAlter">Respecto al tratamiento de los datos de carácter personal del Cliente, las partes intervinientes aceptan que DIGITEL TS pueda tener acceso a dichos datos con la única finalidad de prestar sus servicios. En este sentido, DIGITEL TS será considerado como un encargado del tratamiento por cuenta de la parte emisora y, llevará a cabo el tratamiento de datos personales conforme a lo establecido en el artículo 28 del Reglamento Europeo General sobre Protección de Datos (Reglamento EU 2016/679) y en el artículo 33 de la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, comprometiéndose a cumplir con las obligaciones inherentes a esta figura respecto a la protección y tratamiento de los datos personales a los que tenga acceso. En cualquier caso, la parte emisora garantiza que los datos personales facilitados son veraces y que no infringe ninguna normativa ni vulnera derechos de terceros, asumiendo dicha parte emisora cualquier responsabilidad en este sentido.</p>
            </div>
            <div class="">
                <button @click="openPopUp" class="btnClose btnPopUp">Cerrar</button>
            </div>
        </div>
        <!-- errors -->
        <div v-if="errorUp" class="boxPop centerCancelDiv popUpShow" ref="popError" id="popUpError">
            <error :numError="numError" v-on:closeError="closeErrorUp"/>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import VueResource from 'vue-resource';
    Vue.use(VueResource)
    window.$ = window.jQuery = require('jquery');
    import settings from "@/settings";
    import constants from '@/assets/environments/constants.json';
    import errorsList from '@/assets/environments/errors.json';

    export default {
        name:'secureAccess',
        data(){
            return{
                payload: {},
                errorMessage: "Tienes que introducir un número válido",
                nif: null,
                validCheck:false,
                showModal:false,
                errorLetter:false,
                errorUp : false,
                numError:null,
                nifLabel:false,
                popUpCancel:false,
                payload:{
                    "id_container":"",
                    "id_notification":"",
                    "id_client":"",
                    "channel": ""
                },
                disabledButton:true,
                refactorEnv:{},
                popUp : false,
                idContractCancel:'',
                linkTo: '',
                token:'',
                countLogin: 0
            }
        },
        created(){
            this.$session.start()
            this.linkTo = window.location.href
        },
        mounted(){
            var vm = this
            vm.nif = vm.$refs.inputNif
            vm.btnNext = vm.$refs.btnNext
            vm.popUp = vm.$refs.popUpCondition
            vm.upSide = vm.$refs.upSide
            vm.nifLabel = vm.$refs.nifLabel
            vm.checkCondition = vm.$refs.checkCondition
            this.$emit('changeVeil',false,false)
        },
        methods:{
            toogleCheck(){
                var vm = this
                if(this.validCheck == true){
                    this.validCheck = false
                    this.disabledButton = true
                    vm.btnNext.classList.remove('botonOrange')
                    vm.btnNext.classList.add('botonGris')
                }
                else{
                    this.validCheck = true
                    this.disabledButton = false
                    vm.btnNext.classList.remove('botonGris')
                    vm.btnNext.classList.add('botonOrange')
                }
            },
            floatNif(){
                var vm = this
                if(vm.nif.value != ""){
                    this.nifLabel = true;
                }
                else{
                    this.nifLabel = false;
                }
            },
            async login(){
                var vm = this
                let urlLog = settings.loginUrl
                this.getUrlParams()
                let headers = {
                  'Content-Type': 'application/json;charset=utf-8',
                  'Access-Control-Allow-Origin': '*',
                  'Access-Control-Allow-Credentials': 'true'
                }
                await this.$http.post(urlLog,this.payload, {headers: headers})
                    .then(response => {
                        this.token=response.data.authorization_token
                        this.$session.set('token',this.token)
                        this.goResume()
                    }).catch((error) =>{
                        if (error?.status === constants.loginError && (error.body?.login_attempts ?? 0) === 0) {
                            this.errorMessage = "Has agotado el número de intentos"
                        }
                        error.status = this.checkError(error.status)
                        this.errorLetter = true;
                    }
                )
            },
            cleanDoc(){
                const reg =/\-|\_|\ /g
                let cleanNumDoc = this.nif.value.replace(reg,'')
                return cleanNumDoc.toUpperCase()
            },
            goResume(){
                var vm = this
                this.$router.push({
                    name:'resumeContract',
                    params:{
                        token:vm.token
                    }
                })
            },
            closeErrorUp(){
                this.errorUp = false
                this.$emit('changeVeil',false, false)
            },
            openPopUp(){
                var vm = this
                if(vm.popUp.classList.contains('popUpHidden')){
                    vm.popUp.classList.remove('popUpHidden')
                    vm.popUp.classList.add('popUpShow')
                    this.$emit('changeVeil',true, false)
                }
                else if(vm.popUp.classList.contains('popUpShow')){
                    vm.popUp.classList.remove('popUpShow')
                    vm.popUp.classList.add('popUpHidden')
                    this.$emit('changeVeil',false, false)
                }
            },
            closePopUp(){
                this.popUp = false
                this.$emit('changeVeil',false, false)
            },
            checkError(errorStatus){
                var error = constants.unknowError
                for( let i in errorsList){
                        if (i == errorStatus){error = errorStatus }
                }
                return error
            },
            getUrlParams() {
                this.payload.id_client = this.cleanDoc()
                this.payload.id_notification = this.$route.params.id_notification
                this.payload.id_container = this.$route.params.id_container
                this.payload.channel = this.$route.query.channel || "SMS"
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ./src/components/secureAccess/secureAccess.vue